export const ELEVATOR_SERVICES_FIELDS = [
  'client',
  'elevator',
  'address',
  'elevatorId',
  'project',
  'period',
  'type',
  'c1',
  'c1Comment',
  'c2',
  'c2Comment',
  'c3',
  'c3Comment',
  'c4',
  'c4Comment',
  'c5',
  'c5Comment',
  'c6',
  'c6Comment',
  'c7',
  'c7Comment',
  'c8',
  'c8Comment',
  'c9',
  'c9Comment',
  'c10',
  'c10Comment',
  'c11',
  'c11Comment',
  'c12',
  'c12Comment',
  'c13',
  'c13Comment',
  'c14',
  'c14Comment',
  'c15',
  'c15Comment',
  'c16',
  'c16Comment',
  'c17',
  'c17Comment',
  'c18',
  'c18Comment',
  'c19',
  'c19Comment',
  'c20',
  'c20Comment',
  'c21',
  'c21Comment',
  'c22',
  'c22Comment',
  'c23',
  'c23Comment',
  'c24',
  'c24Comment',
  'c25',
  'c25Comment',
  'c26',
  'c26Comment',
  'c27',
  'c27Comment',
  'c28',
  'c28Comment',
  'c29',
  'c29Comment',
  'c30',
  'c30Comment',
  'c31',
  'c31Comment',
  'c32',
  'c32Comment',
  'c33',
  'c33Comment',
];
